import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
    this.refresh = this.refresh.bind(this);
  }

  connect() {
    this.attempts = 1;
    this.refresh();
  }

  refresh() {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.remove();
      window.HubSpotConversations.widget.load();
    } else {
      this.attempts += 1;
      if (this.attempts < 10) {
        setTimeout(this.refresh, 1000);
      }
    }
  }
}
